export enum ItemStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    FINISHED = 'finished'
}

export interface SegmentTime {
    start: string,
    end: string
}

export interface SegmentTrame {
    startPoint: google.maps.LatLngLiteral,
    endPoint: google.maps.LatLngLiteral
}

export interface NavigationSteps {
    location: google.maps.LatLngLiteral,
    intructions: string
}

export interface RouteItem {
    status: ItemStatus, 
    position: google.maps.LatLngLiteral,
    segmentTime: SegmentTime,
    segmentTrame: SegmentTrame,
    polylinesPath: google.maps.LatLngLiteral[]
    wayPoints: number[],
    navigationSteps: NavigationSteps[]
}

export interface CustomMarkerOptions  { 
    itemLocation: google.maps.LatLngLiteral, 
    itemHeading: number, 
    itemDistance: number
    distanceAlongPath?: any
}

export interface PolyPoint {
  lat: number; lng: number; s: number;  // ← distancia acumulada
}

export interface Snap {
  s: number;                 // distancia acumulada
  point: google.maps.LatLng; // punto proyectado
  dist?: number;              // distancia perpendicular
  segIdx: number;            // índice de segmento elegido
}